import React, {useEffect, useState} from 'react';
import useCommon from '@utils/hooks/common';
import TournamentNotification from '../TournamentNotification';

interface NotificationItem {
  id: string;
  targetRef: React.RefObject<HTMLElement>;
  message: string;
  isVisible: boolean;
}

const TournamentNotificationsContainer: React.FC = () => {
  const {system, socket, t} = useCommon({
    withTranslation: ['game_room'],
    observers: ['system', 'socket'],
  });

  const [notifications, setNotifications] = useState<NotificationItem[]>([]);

  // Register a notification for a specific tab bubble
  const registerNotification = (
    id: string,
    targetRef: React.RefObject<HTMLElement>,
    message: string
  ) => {
    setNotifications(prev => [
      ...prev.filter(n => n.id !== id), // Remove existing notification with same ID
      {id, targetRef, message, isVisible: true},
    ]);
  };

  // Hide a notification
  const hideNotification = (id: string) => {
    setNotifications(prev => prev.map(n => (n.id === id ? {...n, isVisible: false} : n)));

    // Clean up after animation
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 300);
  };

  // Listen for tournament notifications from system
  useEffect(() => {
    const handleTournamentNotification = data => {
      console.log('handleTournamentNotification', data);
      if (data && data.tabBubbleRef && data.roomCode) {
        registerNotification(data.roomCode, data.tabBubbleRef, t('tournament:tournament_started'));
      }
    };

    const handleDismissTournamentNotification = roomCode => {
      console.log('handleDismissTournamentNotification', roomCode);
      hideNotification(roomCode);
    };

    // Subscribe to system events
    system.on('tournamentNotification', handleTournamentNotification);
    system.on('dismissTournamentNotification', handleDismissTournamentNotification);
    return () => {
      system.off('tournamentNotification', handleTournamentNotification);
      system.off('dismissTournamentNotification', handleDismissTournamentNotification);
    };
  }, [system, t]);

  return (
    <>
      {notifications.map(notification => (
        <TournamentNotification
          key={notification.id}
          targetRef={notification.targetRef}
          message={notification.message}
          isVisible={notification.isVisible}
          onClose={() => hideNotification(notification.id)}
        />
      ))}
    </>
  );
};

export default TournamentNotificationsContainer;
